import React from "react";

import { LazyImg } from "@/components/Fetcher";
import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { ICompany } from "@/data/companies";
import { Img } from "@/eworkitComponents";

import "./_context-switcher-logo-section.scss";

interface ICompanyContextSwitcherLogoProps {
  company: ICompany;
}

export const CompanyContextSwitcherLogo: React.FC<ICompanyContextSwitcherLogoProps> = React.memo(({ company }) => {
  const baseClassName = "context-switcher-logo-section";

  const placeholder = <Icon icon="company" className={`${baseClassName}__logo-placeholder`} color="grey4" />;

  return (
    <>
      {company.logo ? (
        company.logo.publicUrl ? (
          <div>
            <Img src={company.logo.publicUrl} className={`${baseClassName}__img`} />
          </div>
        ) : (
          <LazyImg key={company.logo.id} systemId={company.logo.systemId}>
            {({ payload, error }) => (
              <div>
                {payload && payload.publicUrl && <Img src={payload.publicUrl} className={`${baseClassName}__img`} />}
                {!payload && error && placeholder}
              </div>
            )}
          </LazyImg>
        )
      ) : (
        placeholder
      )}
      <Text size="lg" weight="bold">
        {company.name}
      </Text>
    </>
  );
});
